import * as Yup from 'yup'

const minYear: number = Number(new Date().getFullYear() - 80);
const currentYear: number = Number(new Date().getFullYear());

export const yearYup = Yup.number()
.typeError('Year must be a number')
.min(minYear, "Minimum allowed year is " + minYear)
.max(currentYear, "Maximum allowed year is " + currentYear)
.nullable();